import { useEffect, useState } from 'react';

import classes from './BrandSelection.module.scss';
import { useSessionActions } from 'actions/session-actions';
import { useAppSelector } from 'setup/store';
import { useBrandActions } from 'actions/brand-actions';
import { useStoreActions } from 'actions/store-actions';
import { IBrand } from 'common/interfaces/ibrand';
import { Alert, Box, Button, Grid } from '@mui/material';
import ImageBox from 'components/lib/image-box/ImageBox';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAppActions } from 'actions/app-actions';
import LoadingSpinner from 'components/lib/UI/loadingSpinner/LoadingSpinner';

const BrandSelection = () => {
  const brands = useAppSelector((state) => state.brandReducer.brands);
  const isLoading = useAppSelector((state) => state.brandReducer.loading);
  const config = useAppSelector((state) => state.appReducer.appConfig);
  const selectedBrand = useAppSelector((state) => state.sessionReducer.selectedBrand);
  const location = useLocation();

  const { loadAllBrands } = useBrandActions();
  const { loadAllStores } = useStoreActions();
  const { setSelectedBrand } = useSessionActions();
  const { logoutUser } = useAppActions();
  const navigate = useNavigate();

  const [_brands, setBrands] = useState<IBrand[]>();

  useEffect(() => {
    if (brands && brands.items && brands.items.length > 0) {
      setBrands(brands.items);
    } else {
      setBrands([]);
    }
  }, [brands]);

  const _onItemPressed = async (brand: IBrand) => {
    console.log('_onItemPressed:::', brand);
    if (brand) {
      setSelectedBrand(brand);
      await loadAllStores(1, config.defaultListSize);
      // navigate(location && location.pathname ? location.pathname : '/stores');
      navigate('/');
    }
  };
  useEffect(() => {
    if (config) {
      loadAllBrands(1, 100);
    }
    console.log('**************');
  }, []);

  const _handleLogout = () => {
    logoutUser();
  };

  return (
    <div className={classes.container}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={4}>
        {isLoading ? <LoadingSpinner /> : true}
        {_brands && _brands.length > 0 ? (
          _brands.map((brand) => (
            <Box
              key={'brand:' + brand.id}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
              sx={{ width: '250px', border: '2px solid', borderRadius: '6px', borderColor: '#ee384e' }}
            >
              <ImageBox<IBrand>
                title={''}
                image={brand.logoUrl}
                data={brand}
                isSelected={selectedBrand && selectedBrand.id === brand.id ? true : false}
                onClick={_onItemPressed}
              />
            </Box>
          ))
        ) : !isLoading ? (
          <Box>
            <Alert severity="warning">No store is assigned to you.</Alert>
            <Button onClick={_handleLogout}>Logout</Button>
          </Box>
        ) : null}
      </Box>
    </div>
  );
};

export default BrandSelection;
